import { useAuth } from 'react-oidc-context'

export function Login() {
  const auth = useAuth()
  return (
    <div className="center-screen">
      <div className="card">
        <h1>Hemägg CRM</h1>
        <p className="muted">Logga in med ditt Hemägg-konto för att fortsätta.</p>
        <button className="primary" onClick={() => void auth.signinRedirect()}>
          Logga in
        </button>
      </div>
    </div>
  )
}
